import * as deepFreeze from 'deep-freeze';
import { IChatDashboardsSettings } from '../types';
import { AT_CHAT_DASHBOARD_SETTINGS_ACTION_SET, TChatDashboardsSettingsAction } from '../actions/types';
import { chatDashboardSettingsReducer } from 'app/store/model/chatDashboardSettings/reducers/chatDashboardSettingsReducer';

const initialState: IChatDashboardsSettings = {};

const _chatDashboardsSettingsReducer = (
    state = initialState,
    action: TChatDashboardsSettingsAction
): IChatDashboardsSettings  => {
    switch (action.type) {
        case AT_CHAT_DASHBOARD_SETTINGS_ACTION_SET:{
            const {boardId, chatDashboardSettingsAction} = action;
            return {
                ...state,
                [boardId]: chatDashboardSettingsReducer(state[boardId], chatDashboardSettingsAction)
            }
        }
        default: {
            return state;
        }
    }
};

export const chatDashboardsSettingsReducer = (
    state = initialState,
    action: TChatDashboardsSettingsAction
): IChatDashboardsSettings  => {
    // @ts-ignore
    if(window.Settings.development) {
        // @ts-ignore
        return deepFreeze(_chatDashboardsSettingsReducer(state, action));
    } else {
        return _chatDashboardsSettingsReducer(state, action);
    }
};
